import { Carousel } from 'antd'
import Image from 'next/image'
import { useMemo, useRef, useState } from 'react'
import { useTranslation } from 'src/utils/i18n'
import Tutorial from './Tutorial'
import PhoneCarousel from './PhoneCarousel'

const StepLayout = ({ step, title }) => {
  const { t } = useTranslation('commonAndroid')

  const [currentSlide, setcurrentSlide] = useState(0)
  const [carousel, setCarousel] = useState(step[0].img)
  const [fullScreen, setFullScreen] = useState()

  const Handler = index => {
    setCarousel(step[index].img)
    setcurrentSlide(index)
  }

  return (
    <div className='w-full flex flex-col items-center'>
      <h2 className='text-[24px] text-[#282938] font-[600] mx-auto text-center'>{title}</h2>
      <div className='mt-[50px] Dsm:mt-[36px] w-[600px] Dsm:w-full flex justify-between'>
        {/* left */}
        <div className='w-[360px] Dsm:w-full pt-[128px] pb-[52px] Dsm:py-0 flex flex-col justify-between flex-1'>
          <div className='pl-[9px] pr-[23px] Dsm:px-0'>
            {step.map((item, i) => (
              <div
                key={i}
                className={`${i != 0 ? 'mt-[9px] Dsm:mt-[8px]' : ''} flex cursor-pointer`}
                onClick={() => Handler(i)}
              >
                <div
                  className={`${currentSlide == i ? 'text-[#FFF] bg-[#2A99FF]' : ''
                    } text-[14px] min-w-[20px] h-[20px] rounded-[50%] flex justify-center items-center mt-[1.5px]`}
                >
                  {i + 1}.
                </div>
                &ensp;{item.title}
              </div>
            ))}
          </div>
        </div>
        {/* right */}
        <PhoneCarousel
          className='Dsm:hidden'
          step={step}
          currentSlide={currentSlide}
          setcurrentSlide={setcurrentSlide}
          carousel={carousel}
          setCarousel={setCarousel}
        />
      </div>
      <div className='hidden Dsm:flex flex-col items-center my-[46px]' onClick={() => setFullScreen(true)}>
        <Image src='/images/android/setup/view.svg' width={39} height={34} alt='view' />
        <p className='mt-[14px] text-[14px] text-[#2405F2] font-[600]'>{t('Watch a tutorial')}</p>
      </div>
      {/* 弹窗 */}
      {fullScreen && <Tutorial step={step} onClose={() => setFullScreen(false)} />}
    </div>
  )
}

export default StepLayout
